import { isToday } from './utils'

// export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}K` : num)

export const kFormatter = num => { // Dorukhan
  // daha sonra optimize edilecek
  let FormattedNum
  FormattedNum = `${num}`
  // Handle extremely small numbers due to floating point errors or other issues
  if (Math.abs(num) < 0.01 || num === 0) {
    return '0';
  }
  if (num > 999) {
    if ((num / 1000) > 999) {
      if ((num / 1000000) > 999) {
        FormattedNum = `${Number((num / 1000000000).toFixed(1))}B`
      } else {
        FormattedNum = `${Number((num / 1000000).toFixed(1))}M`
      }
    } else {
      FormattedNum = `${Number((num / 1000).toFixed(1))}K`
    }
  }
  return FormattedNum
}
export const title = (value, replacer = ' ') => {
  if (!value) return ''
  const str = value.toString()

  const arr = str.split(replacer)
  const capitalizedArray = []
  arr.forEach(word => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalizedArray.push(capitalized)
  })
  return capitalizedArray.join(' ')
}

export const avatarText = value => {
  if (!value) return ''
  const nameArray = value.split(' ')
  return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
}

/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 * Return short human friendly month representation of date
 * Can also convert date to only time if date is of today (Better UX)
 * @param {String} value date to format
 * @param {Boolean} toTimeForCurrentDay Shall convert to time if day is today/current
 */
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// Strip all the tags from markup and return plain text
export const filterTags = value => value.replace(/<\/?[^>]+(>|$)/g, '')

// Format all values of an array of string to number
export const formatArrayAsNumber = array => array.map(value => Number(value) || 0)

export const formatDateTime = (timestamp, isPicker) => {
  // const [year, month, day] = new Date(timestamp).toJSON().split('T')[0].split('-')
  const [year, month, day] = new Date(new Date(timestamp).getTime() - (new Date(timestamp).getTimezoneOffset() * 60000)).toJSON().split('T')[0].split('-')
  return isPicker ? `${month}/${day}/${year}` : `${year}-${month}-${day}`
}

export const numberFormatter = (val) => {
  if (Math.abs(val) < 0.01) {
    return 0;
  } else {
    return val.toFixed(2);
  }
}

